import type { Update } from '@ngrx/entity';
import type { Uuid } from '@common/types';
import type { NormalizedGridEntity, DenormalizedGridEntity } from '@web/types';

import { createActionGroup, props } from '@ngrx/store';

const GridsActions = createActionGroup({
    source: 'PageStructure/Grids',
    events: {
        init: props<{ entities: NormalizedGridEntity[] }>(),
        add: props<{ entity: DenormalizedGridEntity; order: number }>(),
        added: props<{ entity: NormalizedGridEntity; order: number }>(),
        'Added many': props<{ entities: NormalizedGridEntity[] }>(),
        create: props<{
            parentId: Uuid;
            order: number;
            variant?: number;
            skipHistory?: boolean;
        }>(),
        created: props<{
            order: number;
            entity: NormalizedGridEntity;
            skipHistory?: boolean;
        }>(),
        copy: props<{ entity: DenormalizedGridEntity; order?: number }>(),
        copied: props<{ entity: NormalizedGridEntity; order: number }>(),
        'Update properties': props<{ update: Update<NormalizedGridEntity> }>(),
        'Update many properties': props<{ updates: Update<NormalizedGridEntity>[] }>(),
        'Copy many': props<{ entities: NormalizedGridEntity[] }>(),
        Remove: props<{ entity: DenormalizedGridEntity; order: number; skipHistory?: boolean }>(),
        'Move widget from grid to column': props<{
            widgetId: string;
            prevGridCellIndex: number;
            prevParentId: string;
            nextParentId: string;
            prevIndex: number;
            nextIndex: number;
            skipHistory?: boolean;
        }>(),
        'Move widget from column to grid': props<{
            widgetId: string;
            nextGridCellIndex: number;
            prevParentId: string;
            nextParentId: string;
            prevIndex: number;
            nextIndex: number;
            skipHistory?: boolean;
        }>(),
        'Move widget from grid to grid': props<{
            widgetId: string;
            prevGridCellIndex: number;
            nextGridCellIndex: number;
            prevParentId: string;
            nextParentId: string;
            prevIndex: number;
            nextIndex: number;
            skipHistory?: boolean;
        }>(),
    },
});

export default GridsActions;
